import React, {Component} from 'react'
import {authenticationService} from "../../services/AuthenticationService";
import '../../style/main.css'
import {history} from "../../utils/history";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

class PatientDailyReportComposed extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {

        let search = history.location.search

        if (search) {
            search = search.substring(1)
            let searchArr = search.split('&')
            let patientID = searchArr[1].substring(10)
            let token = searchArr[0].substring(6)
            if (token && patientID) {
                let response = await authenticationService.getPatientFromRoute( token, patientID)
                let data = response.data
                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    let patientInfo = data
                    history.push({
                        pathname: `/national_pain_management_dailyReport`,
                        state: {
                            patientInfo,
                        },
                    })
                }
            }
        }

    }


    render() {
        return (
            <div className={'patientForm-box-container'}>
                {/*<FormElementContainerResponsive title={t('patient_self_boarding.Lifestyle')}
                                                Component={LeumitSelfLifestyle}
                                                tabInternalView={this.state.tabInternalView}
                                                currentContainerView={3}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                    changeView: (view) => this.changeView(view),
                                                    entry: this.props.entry,
                                                    errors: this.props.errors,
                                                    t: (e) => this.props.t(e),
                                                }}/>*/}
            </div>

        )
    }
}
let PatientDailyReport = compose(
    withTranslation()
)(PatientDailyReportComposed)
export default PatientDailyReport;
